import {
  onAuthStateChanged,
  signInWithEmailAndPassword,
  updateProfile,
  updateEmail,
  updatePassword,
  signOut,
} from "firebase/auth";

import { auth } from "../config/firebase";
import store from "../store";
import { setAdmin, setLoading } from "../store/slices/adminSlice";
import { notification } from "antd";

export const adminLogin = async (payload) => {
  try {
    store.dispatch(setLoading(true));
    const { email, password } = payload;
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error) {
    console.log("Sign in Error:", error.message);
    let _error = "";
    if (error?.message?.includes("auth/user-not-found")) {
      _error = "User not found";
    } else if (error?.message?.includes("auth/wrong-password")) {
      _error = "Wrong Password";
    } else {
      _error = "Something went wrong";
    }
    notification.error({
      message: "Error",
      description: _error,
    });
  } finally {
    store.dispatch(setLoading(false));
  }
};

// export const authStateChanged = () => {
//   onAuthStateChanged(auth, (admin) => {
//     if (admin) {
//       const _admin = {
//         accessToken: admin?.accessToken,
//         displayName: admin?.displayName,
//         email: admin?.email,
//         uid: admin?.uid,
//         photoURL: admin?.photoURL,
//       };
//       store.dispatch(setAdmin(_admin));
//       return _admin;
//     } else {
//       console.log("User is signed out");
//     }
//   });
// };
export const authStateChanged = () => {
  return new Promise((resolve, reject) => {
    onAuthStateChanged(auth, (admin) => {
      if (admin) {
        const _admin = {
          accessToken: admin?.accessToken,
          displayName: admin?.displayName,
          email: admin?.email,
          uid: admin?.uid,
          photoURL: admin?.photoURL,
        };
        store.dispatch(setAdmin(_admin));
        resolve(_admin);
      } else {
        console.log("User is signed out");
        resolve(null);
      }
    });
  });
};

export const updateAdminProfile = async (displayName) => {
  try {
    const profileUpdated = updateProfile(auth.currentUser, {
      displayName,
    });
    if (profileUpdated) {
      console.log("Profile updated Successfully");
    }
  } catch (error) {
    console.log("Update Profile Error:", error.message);
  }
};

export const updateAdminEmail = async (email) => {
  try {
    const emailUpdated = updateEmail(auth.currentUser, email);
    if (emailUpdated) {
      console.log("Email updated Successfully");
    }
  } catch (error) {
    console.log("Update Email Error:", error.message);
  }
};

export const updateAdminPassword = async (password) => {
  try {
    const passwordUpdated = updatePassword(auth.currentUser, password);
    if (passwordUpdated) {
      console.log("Passowrd updated Successfully");
    }
  } catch (error) {
    console.log("Update Password Error:", error.message);
  }
};

export const logout = async () => {
  try {
    const isSignout = signOut(auth);
    if (isSignout) {
      store.dispatch(setAdmin(null));
      console.log("Signout Successfully");
    }
  } catch (error) {
    console.log("Signout Error:", error.message);
  }
};
